// import home from "../images/Pocetna/brandNeWW.mp4";
// import home1 from "../images/Pocetna/brandNeWW.webm";
// import home2 from "../images/Pocetna/brandNeWW.mov";
// import test from "../images"
//homePage
import prva from "../images/Pocetna/Sliki/1Fx.webp";
import vtora from "../images/Pocetna/Sliki/2Fx.webp";
import treta from "../images/Pocetna/Sliki/3Fx.webp";
import cetvrta from "../images/Pocetna/Sliki/4FxA.webp";
import petta from "../images/Pocetna/Sliki/5Fx.webp";
import shesta from "../images/Pocetna/Sliki/6Fx.webp";
import sedma from "../images/Pocetna/Sliki/7Fx.webp";
import osma from "../images/Pocetna/Sliki/8Fx.webp";
import deveta from "../images/Pocetna/Sliki/9Fx.webp";
import deseta from "../images/Pocetna/Sliki/10FxA.webp";
import edinaesta from "../images/Pocetna/Sliki/11FxA.webp";
import dvanesta from "../images/Pocetna/Sliki/12Fx.webp";
import trinaesta from "../images/Pocetna/Sliki/13Fx.webp";
import cetirinaesta from "../images/Pocetna/Sliki/14Fx.webp";
import petnaesta from "../images/Pocetna/Sliki/15Fx.webp";

import services from "../images/Pocetna/services.jpg";
import cases from "../images/Pocetna/cases.jpg";
import aboutus from "../images/Pocetna/aboutUs.jpg";

import contactBg from "../images/Pocetna/contactBg.jpg";
import aboutUsBg from "../images/Pocetna/aboutUsBg.jpg";
//------------------------------------------------------
//cases
import MetalCeramics1 from "../images/CasesMetalCeramics/MetalCeramics1.jpg";
import MetalCeramics2 from "../images/CasesMetalCeramics/MetalCeramics2.jpg";
import MetalCeramics3 from "../images/CasesMetalCeramics/MetalCeramics3.jpg";
import MetalCeramics4 from "../images/CasesMetalCeramics/MetalCeramics4.jpg";
import MetalCeramics5 from "../images/CasesMetalCeramics/MetalCeramics5.jpg";
import MetalCeramics6 from "../images/CasesMetalCeramics/MetalCeramics6.jpg";
import MetalCeramics7 from "../images/CasesMetalCeramics/MetalCeramics7.jpg";
import MetalCeramics8 from "../images/CasesMetalCeramics/MetalCeramics8.jpg";
import MetalCeramics9 from "../images/CasesMetalCeramics/MetalCeramics9.jpg";
import MetalCeramics10 from "../images/CasesMetalCeramics/MetalCeramics10.jpg";
import MetalCeramics11 from "../images/CasesMetalCeramics/MetalCeramics11.jpg";
import MetalCeramics12 from "../images/CasesMetalCeramics/MetalCeramics12.jpg";

import bezmetalna1 from "../images/CasesMetalFreeCeramics/bezmetalna1.jpg";
import bezmetalna2 from "../images/CasesMetalFreeCeramics/bezmetalna2.jpg";
import bezmetalna3 from "../images/CasesMetalFreeCeramics/bezmetalna3.jpg";
import bezmetalna4 from "../images/CasesMetalFreeCeramics/bezmetalna4.jpg";
import bezmetalna5 from "../images/CasesMetalFreeCeramics/bezmetalna5.jpg";
import bezmetalna6 from "../images/CasesMetalFreeCeramics/bezmetalna6.jpg";
//^^^cases^^^

import MetalCerIntro from "../images/MoreMetalCeramics/Intro/MetalCerIntro.webp";
import metalCer01a from "../images/MoreMetalCeramics/Content/01.webp";
import metalCer01 from "../images/MoreMetalCeramics/Content/01a.webp";
import metalCer1 from "../images/MoreMetalCeramics/Content/1aWW.webp";
import metalCer2 from "../images/MoreMetalCeramics/Content/2bWW.webp";
import metalCer3 from "../images/MoreMetalCeramics/Content/3WW.webp";
import metalCer4 from "../images/MoreMetalCeramics/Content/4WW.webp";
import metalCer5 from "../images/MoreMetalCeramics/Content/5WW.webp";
import metalCer6 from "../images/MoreMetalCeramics/Content/6WW.webp";
import metalCer7 from "../images/MoreMetalCeramics/Content/7WW.webp";
import metalCer8 from "../images/MoreMetalCeramics/Content/8WW.webp";
import metalCer1011 from "../images/MoreMetalCeramics/Content/metalceramics1011WW.webp";
import metalCer12 from "../images/MoreMetalCeramics/Content/12WW.webp";
import metalCer12A from "../images/MoreMetalCeramics/Content/12aWW.webp";
import metalCer13 from "../images/MoreMetalCeramics/Content/13WW.webp";
import metalCer14 from "../images/MoreMetalCeramics/Content/14WW.webp";
import metalCer15 from "../images/MoreMetalCeramics/Content/15WW.webp";
import metalCer16 from "../images/MoreMetalCeramics/Content/16WW.webp";
import metalCer17 from "../images/MoreMetalCeramics/Content/17aWW.webp";

import cmIntro from "../images/MoreColorMatching/Intro/cmIntro.webp";
import cm1 from "../images/MoreColorMatching/Content/cm1WW.webp";
import cm2 from "../images/MoreColorMatching/Content/cm2WW.webp";
import cm3 from "../images/MoreColorMatching/Content/cm3WW.webp";
import cm4 from "../images/MoreColorMatching/Content/cm4WW.webp";
import cm5 from "../images/MoreColorMatching/Content/cm5WW.webp";

import mfcIntro from "../images/MoreMetalFreeCeramics/Intro/metalFreePocetna.webp";
import mfc1 from "../images/MoreMetalFreeCeramics/Content/1WW.webp";
import mfc2 from "../images/MoreMetalFreeCeramics/Content/2aWW.webp";
import mfc3 from "../images/MoreMetalFreeCeramics/Content/3WW.webp";
import mfc4 from "../images/MoreMetalFreeCeramics/Content/4WW.webp";
import mfc5 from "../images/MoreMetalFreeCeramics/Content/5WW.webp";
import mfc6 from "../images/MoreMetalFreeCeramics/Content/6WW.webp";
import mfc7 from "../images/MoreMetalFreeCeramics/Content/7WW.webp";
import mfc8 from "../images/MoreMetalFreeCeramics/Content/8WW.webp";
import mfc9 from "../images/MoreMetalFreeCeramics/Content/9WW.webp";
import mfc10 from "../images/MoreMetalFreeCeramics/Content/10WW.webp";
import mfc11 from "../images/MoreMetalFreeCeramics/Content/11.webp";
import mfc11a from "../images/MoreMetalFreeCeramics/Content/11a.webp";
import mfc12 from "../images/MoreMetalFreeCeramics/Content/12WW.webp";
import mfc13 from "../images/MoreMetalFreeCeramics/Content/13WW.webp";
import mfc14 from "../images/MoreMetalFreeCeramics/Content/14WW.webp";
import mfc15 from "../images/MoreMetalFreeCeramics/Content/15aWW.webp";
import mfc16Dark from "../images/MoreMetalFreeCeramics/Content/16DarkWW.webp";
import mfc17Light from "../images/MoreMetalFreeCeramics/Content/16LightWW.webp";
import mfc18Dark from "../images/MoreMetalFreeCeramics/Content/17DarkWW.webp";
import mfc19Light from "../images/MoreMetalFreeCeramics/Content/17LightWW.webp";
import mfc20 from "../images/MoreMetalFreeCeramics/Content/18aWW.webp";
import mfc21Dark from "../images/MoreMetalFreeCeramics/Content/19DarkWW.webp";
import mfc22Light from "../images/MoreMetalFreeCeramics/Content/19LightWW.webp";

import MobileProstIntroLight from "../images/MoreRemovableDentures/Intro/pocetnaMobilnaLight2.webp";
import MobileProstIntroDark from "../images/MoreRemovableDentures/Intro/pocetnaMobilnaDark.webp";
import MobileProst1 from "../images/MoreRemovableDentures/Content/1.webp";
import MobileProst2 from "../images/MoreRemovableDentures/Content/2.webp";
import MobileProst3 from "../images/MoreRemovableDentures/Content/3WW.webp";
import MobileProst4 from "../images/MoreRemovableDentures/Content/3AWW.webp";
import MobileProst5 from "../images/MoreRemovableDentures/Content/3BWW.webp";
import MobileProst6 from "../images/MoreRemovableDentures/Content/4WW.webp";
import MobileProst7 from "../images/MoreRemovableDentures/Content/5WW.webp";
import MobileProst8 from "../images/MoreRemovableDentures/Content/6WW.webp";
import MobileProst9 from "../images/MoreRemovableDentures/Content/7WW.webp";
import MobileProst10 from "../images/MoreRemovableDentures/Content/8WW.webp";
import MobileProst11Dark from "../images/MoreRemovableDentures/Content/9DarkWW.webp";
import MobileProst11Light from "../images/MoreRemovableDentures/Content/9LightWW.webp";
import MobileProst12Dark from "../images/MoreRemovableDentures/Content/10DarkWW.webp";
import MobileProst12Light from "../images/MoreRemovableDentures/Content/10LightWW.webp";
import MobileProst13 from "../images/MoreRemovableDentures/Content/11WW.webp";
import MobileProst14Dark from "../images/MoreRemovableDentures/Content/12DarkWW.webp";
import MobileProst14Light from "../images/MoreRemovableDentures/Content/12LightWW.webp";
import MobileProst15Dark from "../images/MoreRemovableDentures/Content/13DarkWW.webp";
import MobileProst15Light from "../images/MoreRemovableDentures/Content/13LightWW.webp";
import MobileProst16Dark from "../images/MoreRemovableDentures/Content/14DarkWW.webp";
import MobileProst16Light from "../images/MoreRemovableDentures/Content/14LightWW.webp";
import MobileProst17Dark from "../images/MoreRemovableDentures/Content/15DarkWW.webp";
import MobileProst17Light from "../images/MoreRemovableDentures/Content/15LightWW.webp";
import MobileProst18Dark from "../images/MoreRemovableDentures/Content/16DarkWW.webp";
import MobileProst18Light from "../images/MoreRemovableDentures/Content/16LightWW.webp";
import MobileProst19Dark from "../images/MoreRemovableDentures/Content/17DarkWW.webp";
import MobileProst19Light from "../images/MoreRemovableDentures/Content/17LightWW.webp";

import waxupIntroDark from "../images/WaxUp/Intro/waxupPocetnaDark.webp";
import waxupIntroLight from "../images/WaxUp/Intro/waxupPocetnaLight.webp";
import waxup from "../images/WaxUp/Content/waxup.webp";
import waxup01 from "../images/WaxUp/Content/waxup01.webp";
import waxup01a from "../images/WaxUp/Content/waxup01aWW.webp";
import waxup123 from "../images/WaxUp/Content/waxup123WW.webp";
import waxup456 from "../images/WaxUp/Content/waxup456WW.webp";
import waxup7a from "../images/WaxUp/Content/waxup7aWW.webp";
import waxup8 from "../images/WaxUp/Content/waxup8WW.webp";

import retIntro from "../images/Retainers/Intro/retIntro.webp";
import ret1 from "../images/Retainers/Content/ret1WW.webp";
import ret2 from "../images/Retainers/Content/ret2WW.webp";
import ret3 from "../images/Retainers/Content/ret3WW.webp";
import ret4 from "../images/Retainers/Content/ret4WW.webp";

import dsdIntro from "../images/DigitalSmileDesign/Intro/pocetnaDSD.jpg";
import dsd2 from "../images/DigitalSmileDesign/Content/digitalSmileDesign2.webp";
import dsd3edit from "../images/DigitalSmileDesign/Content/dsd3edit.webp";
import dsd4 from "../images/DigitalSmileDesign/Content/digitalSmileDesign4.webp";
import dsd7edit from "../images/DigitalSmileDesign/Content/dsd7edit.webp";

import ConsultationsIntro from "../images/Consultations/Intro/ConsultationsIntro.webp";
import Consultations1 from "../images/Consultations/Content/Consultations1.webp";
import Consultations2 from "../images/Consultations/Content/Consultations2.webp";
import Consultations3 from "../images/Consultations/Content/Consultations3.webp";

import PhotographyIntro from "../images/Photography/PhotographyIntro.webp";
import Photography1 from "../images/Photography/Photography1.webp";
import Photography2 from "../images/Photography/Photography2.webp";

import {
  DownButton,
  ReadMoreButton,
  ViewMoreCasesButton,
} from "../components/home/index";

export const HomeSlider = [
  prva,
  vtora,
  treta,
  cetvrta,
  petta,
  shesta,
  sedma,
  osma,
  deveta,
  deseta,
  edinaesta,
  dvanesta,
  trinaesta,
  cetirinaesta,
  petnaesta,
];

export const homeSections = [
  {
    className: "slide",
    id: "home",
    // videoSrc: home,
    // videoSrc1: home1,
    // videoSrc2: home2,
    sliderSrc: HomeSlider,
    opacity: 1,
    contentIntroTitle: "Designing smiles beyond imagination.",
    subtitle:
      "At Kreativa we bring together state-of-the-art technology and an exceptional team, because superior quality and consistency come first for us.",
    btnData: <DownButton />,
  },
  {
    className: "slide",
    id: "services",
    imgSrc: services,
    opacity: 0.7,
    title: "SERVICES",
    contentIntroTitle:
      "Some of the things we do to <span className='white-text'>brighten</span> your day",
    subtitle: "Removable Dentures, metal & metal-free ceramics.",
    btnData: <ReadMoreButton whereTo="/services" text="READ MORE" />,
  },
  {
    className: "slide",
    id: "cases",
    imgSrc: cases,
    imgStyles: { backgroundSize: "auto" },
    opacity: 0.5,
    title: "CASES",
    contentIntroTitle: "A smile remains the most inexpensive gift...",
    subtitle:
      "Removable dentures, metal & metal-free ceramics are few of the options that we make. Click to view cases for before and after.",
    btnData: <ReadMoreButton whereTo="/view-cases" text="VIEW CASES" />,
  },
  {
    className: "slide",
    id: "about-us",
    imgSrc: aboutus,
    opacity: 0.5,
    contentIntroTitle: "Who are we?",
    subtitle:
      "Kreativa Laboratory is known for always being up to date with the latest technology in the field of prosthetics, as well as its expansion in dentists.",
    btnData: <ReadMoreButton whereTo="/about-us" text="VIEW MORE" />,
  },
];

export const FeelFreeIntro = {
  text: "Feel free to ask us any questions",
};

export const ContactBgData = {
  imgSrc: contactBg,
  opacity: 0.3,
}; //Contact us stranata koga kje stisnat na CONTACT kopceto

export const AboutUsData = {
  imgSrc: aboutUsBg,
  opacity: 0.3,
  text: "<p>The dental laboratory for prosthetics Kreativa was founded in 2009, by the owner Bojan Andonovski. After graduating from the Faculty of Dentistry at St. Cyril and Methodius University, he continued to upgrade and improve his work and education in the field of prosthetics through his work experience in ProMedica, as well as in other private laboratories. Kreativa's first laboratory was located in Skopje, in the center of the city, and consisted of Bojan and another graduated dental prosthetist. The laboratory then worked for only a few local dentists.</p><p> The focus of Kreativa is to provide high quality restorations, with special attention paid to the end result, aesthetics, consistency, as well as providing excellent service to its customers. Today, the Kreativa laboratory has expanded, providing services to many dentists, not only in the city center, but throughout Skopje and Macedonia.</p><p> Never deviating from the essential focus of high quality and excellent customer service, we have expanded to create products and services for dentists, while offering faster, more cost-effective restorations. All restorations were made in Macedonia.</p><p> Creative Lab is known for always being up to date with the latest technology in the field of prosthetics, as well as its expansion in dentists. From CAD / CAM design and shaping to digital projection, our work has been featured in numerous articles. We are the number one partner of Acibadem Sistina according to the ranking of our work.</p><p> Consistent, superior quality and excellent, efficient service. That is our promise!</p>",
}; //About us stranata koga kje stisnat na kopceto od slajdot;

//----------------------------CASES->VIEW MORE------------------------
const MetalCeramicsArr = [
  {
    img: MetalCeramics1,
    text: "Before Treatment",
  },
  {
    img: MetalCeramics2,
    text: "After Treatment",
  },
];

const MetalFreeCeramicsArr = [
  {
    img: bezmetalna1,
    text: "Before Treatment",
  },
  {
    img: bezmetalna2,
    text: "After Treatment",
  },
];

export const ImageComparisons = [
  {
    id: 1,
    title: "Metal Ceramics",
    imageCompArr: MetalCeramicsArr,
    btnData: <ViewMoreCasesButton whereTo="view-more-metal-ceramics" />,
  },
  {
    id: 2,
    title: "Metal-free Ceramics",
    imageCompArr: MetalFreeCeramicsArr,
    btnData: <ViewMoreCasesButton whereTo="view-more-metal-free-ceramics" />,
  },
]; //viewCases koga kje stisnat, intro sliki so kopce za povekje primeri;

//--------------------SERVICES-------------------
export const ServicesDisplayed = [
  {
    dark: {
      id: "metal-ceramics",
      imgSrc: MetalCerIntro,
      title: "Metal Ceramics",
      introText:
        "<p>The biggest advantage of the ceramic restoration is its permanent aesthetic quality.</p> Since there is a solid connection between the masking ceramic and the metal, almost no changes of color will occur in the ceramic construction.",
    },
  },
  {
    dark: {
      id: "metal-free-ceramics",
      imgSrc: mfcIntro,
      title: "Metal-free Ceramics",
      introText:
        "<p>One of the most important features is biocompatibility.</p> The body accepts this material without any reaction in the form of allergies and inflammation, because some metal alloys for metal-ceramic bridges contain too much nickel, which leads to allergic reactions.",
    },
  },
  {
    dark: {
      id: "removable-dentures",
      imgSrc: MobileProstIntroDark,
      title: "Removable Dentures",
      introText:
        "<p>Although much progress has been made in dentistry, tooth loss is still a common problem.</p> There are several options available for patients who have lost their teeth. One of the most commonly used and accepted methods is the placement of mobile prostheses.",
    },
    light: {
      id: "removable-dentures",
      imgSrc: MobileProstIntroLight,
      theme: "light",
      title: "Removable Dentures",
      introText:
        "<p>Although much progress has been made in dentistry, tooth loss is still a common problem.</p> There are several options available for patients who have lost their teeth. One of the most commonly used and accepted methods is the placement of mobile prostheses.",
    },
  },

  {
    dark: {
      id: "retainers",
      imgSrc: retIntro,
      title: "Retainers",
      introText:
        "<p>Even after braces have straightened your teeth, they are not entirely secure in their new position. This does not occur until the gums, bones, and muscles adjust to the new situation.</p>",
    },
  },
  {
    dark: {
      id: "wax-up",
      imgSrc: waxupIntroDark,
      title: "Wax Up",
      introText:
        "<p>Wax-up gives you the power of complete control, from start to finish. Having the ability to take certain steps during the process allows each dentist to feel confident about the final procedure.</p>",
    },
    light: {
      id: "wax-up",
      imgSrc: waxupIntroLight,
      title: "Wax Up",
      introText:
        "<p>Wax-up gives you the power of complete control, from start to finish. Having the ability to take certain steps during the process allows each dentist to feel confident about the final procedure.</p>",
    },
  },
  {
    dark: {
      id: "digital-smile-design",
      imgSrc: dsdIntro,
      title: "Digital Smile Design",
      introText:
        "<p>DSD is a technical instrument that is used to design and change patients' smiles digitally and to help them imagine it beforehand by developing and showing a digital mockup of their new smile design before the therapy physically begins.</p>",
    },
  },
  {
    dark: {
      id: "color-matching",
      imgSrc: cmIntro,
      title: "Color Matching",
      introText:
        "<p>The color of some human teeth is an approximate color of the common shades of the color key found in all dental laboratories / surgeries.</p> If your teeth are close to these shades, your doctor can help you successfully choose the shade that matches the natural color of your teeth.",
    },
  },
  // {
  //   id: "new-route",
  //   imgSrc: ColorMatIntro,
  //   title: "New Section",
  //   introText:
  //     "<p>The color of some human teeth is an approximate color of the common shades of the color key found in all dental laboratories / surgeries.</p> If your teeth are close to these shades, your doctor can help you successfully choose the shade that matches the natural color of your teeth.",
  // }, //new-section AREA
  {
    dark: {
      id: "consultations",
      imgSrc: ConsultationsIntro,
      title: "Consultations",
      introText:
        "<p>We help and support our dentists and colleagues, not only in their work but also through consultations in specific areas. That way we can help doctor offices and laboratories to establish essential protocols for successful business that we use for ourselves.",
    },
  },
  {
    dark: {
      id: "dental-photography",
      imgSrc: PhotographyIntro,
      title: "Dental Photography",
      introText:
        "<p>Digital dental photography is an inevitable part of our everyday life. In order to document the cases and processes correctly and with good quality, we have to collect the material for presentations, education and the rest, we have to have professional equipment. Cameras on our smartphones and so on, are not enough.",
    },
  },
]; //Services

// ----------services -> view more on metal ceramics;-------------------------
export const AllImagesMC = [
  metalCer01a,
  metalCer01,
  metalCer1,
  metalCer2,
  metalCer3,
  metalCer4,
  metalCer5,
  metalCer6,
  metalCer7,
  metalCer8,
  metalCer1011,
  metalCer12,
  metalCer12A,
  metalCer13,
  metalCer14,
  metalCer15,
  metalCer16,
  metalCer17,
];

export const TitleMCeramics = {
  title: "Metal Ceramics",
};

export const MetalCeramicsPage = {
  imgArr: AllImagesMC,
  imagesObjArr: [
    {
      dark: {
        text: "<p>The biggest advantage of the ceramic restoration is its permanent aesthetic quality. Since there is a solid connection between the masking ceramic and the metal, almost no changes of color will occur in the ceramic construction.</p><p> Metal ceramic crowns are a type of crowns that are most often used for many years, with long-lasting hardness, durability and a satisfactory aesthetics.</p> <p>However, their metal base prevents the passage of light, thus the translucency of these creations is good but not perfect.</p> <p>In addition, allergic reactions to the metal may occur. Usually in patients it is a choice for the back teeth. The biggest advantage of these products is the affordable price.</p>",
        broj: 0,
        columnNum: 2,
        imgs: [{ img: metalCer01a }, { img: metalCer01 }],
      },
    },
    {
      dark: {
        broj: 2,
        columnNum: 3,
        imgs: [
          {
            img: metalCer1,
            text: "<p>Construction made of a 3D printer in resin.</p>",
          },
          { img: metalCer2, text: "<p>Finished metal construction.</p>" },
          { img: metalCer3, text: "<p>Layering of dentin in ceramics.</p>" },
        ],
      },
    },
    {
      dark: {
        broj: 5,
        columnNum: 3,
        imgs: [
          {
            img: metalCer4,
            text: "<p>Final layering with all structural elements in ceramics.</p>",
          },
          { img: metalCer5, text: "<p>Finished metal ceramic bridge.</p>" },
          { img: metalCer6 },
        ],
      },
    },
    {
      dark: {
        broj: 8,
        columnNum: 3,
        imgs: [
          {
            img: metalCer7,
            text: "<p>Production of a circular bridge, cut in a CNC machine.</p>",
          },
          {
            img: metalCer8,
            text: "<p>Making a construction of a circular bridge with a 3D printer in resin.</p>",
          },
          {
            img: metalCer1011,
            text: "<p>Processed and prepared bridge in metal.</p>",
          },
        ],
      },
    },
    {
      dark: {
        broj: 11,
        columnNum: 2,
        imgs: [{ img: metalCer12 }, { img: metalCer12A }],
      },
    },
    {
      dark: {
        broj: 13,
        columnNum: 2,
        imgs: [
          {
            img: metalCer13,
            text: "<p>Production of a frame over implants where the metal structure is made using a metal 3D printer.</p>",
          },
          { img: metalCer14 },
        ],
      },
    },
    {
      dark: {
        broj: 15,
        columnNum: 3,
        imgs: [{ img: metalCer15 }, { img: metalCer16 }, { img: metalCer17 }],
      },
    },
  ],
}; //services -> view more on METAL CERAMICS;

//services -> view more on COLOR MATCHING;
export const AllColorMat = [cm1, cm2, cm3, cm4, cm5];

export const TitleColorMatData = {
  title: "Color Matching",
};

export const ColorMatchingPage = {
  imgArr: AllColorMat,
  imagesObjArr: [
    {
      dark: {
        text: "<p>Each human tooth has a unique combination of colors, which is like a fingerprint. Reproduction of these complex organic tones in ceramic materials is the biggest challenge faced by every dental dentist graduate.</p><p>The color of some human teeth is an approximate color of the common shades of the color key found in all dental laboratories / surgeries. If your teeth are close to these shades, your doctor can help you successfully choose the shade that matches the natural color of your teeth.</p> <p>Many people still have more complex tooth colors that are not in the standard shades of the color key. In this case, a unique shade must be prepared by an experienced prosthetic graduate. It skillfully mixes and applies to the ceramics in several layers to achieve the desired color shade. The most accurate determination of the perfect color of your teeth requires a physical presence in our laboratories for a perfect match of the color with the natural shade of your teeth.</p>",
        broj: 0,
        columnNum: 2,
        imgs: [{ img: cm1 }, { img: cm2 }],
      },
    },
    {
      dark: {
        text: "<p>In our laboratory 'KREATIVA' you will be welcomed by experienced graduate prosthetists who with special correction lights, will determine your natural tooth color in less than 20 minutes.</p><p>The biggest challenge of any dental laboratory is making a crown or veneer at the top in front of the tooth, because even the slightest color difference in a smile can be too obvious. For such cases it is sometimes necessary for the patient to be present at the laboratory for precise matching.</p><p> This personalized painting can take from 40 minutes to several hours, depending on how many times the ceramic needs to be re-baked and re-painted in order to achieve the desired result.</p>",
        broj: 2,
        columnNum: 3,
        imgs: [{ img: cm3 }, { img: cm4 }, { img: cm5 }],
      },
    },
  ],
};
//services -> view more on COLOR MATCHING;
//--------------------------------------------------------------------

//services -> view more on METAL-FREE CERAMICS;
export const AllMFCeramicsImg = [
  mfc11,
  mfc11a,
  mfc12,
  mfc1,
  mfc3,
  mfc2,
  mfc4,
  mfc5,
  mfc6,
  mfc7,
  mfc8,
  mfc9,
  mfc10,
  mfc13,
  mfc14,
  mfc15,
  mfc16Dark,
  mfc18Dark,
  mfc20,
  mfc21Dark,
  mfc17Light,
  mfc19Light,
  mfc20,
  mfc22Light,
];

export const TitleMFCeramics = {
  title: "Metal-free Ceramics",
};

export const MFCeramicsPage = {
  imgArr: AllMFCeramicsImg,
  imagesObjArr: [
    {
      dark: {
        text: "<p>What sets non-metallic ceramics above metal-ceramics are its characteristics. One of the most important features is biocompatibility. The body accepts this material without any reaction in the form of allergies and inflammation, because some metal alloys for metal-ceramic bridges contain too much nickel, which leads to allergic reactions.</p><p>The absence of metal prevents another phenomenon, the occurrence of galvanic currents, which occurs when in the mouth, in the presence of saliva, there are two different charged materials (metal-ceramic crown and amalgam seal). With its firmness it ensures longevity in the mouth, without changes in the structure.</p>",
        broj: 0,
        columnNum: 3,
        imgs: [{ img: mfc11 }, { img: mfc11a }, { img: mfc12 }],
      },
    },
    {
      dark: {
        text: "<p>Metal-free ceramic crowns are made with special technology, CAD / CAM technology (Computer-Aided-Design / Computer-Aided-Manufacture).</p><p>After brushing the teeth, a machine fingerprint follows. Laser scanning is performed based on which the software makes a 3D model of the screen.</p><p>According to this model, the 3D CAD / CAM machine, made of ceramic blocks, forms the basis for the crown.</p><p>The main advantages of zirconium oxide ceramics that are important for oral health and appearance are:</p><p>• Biocompatibility in the mouth with tissues, based on the fact that zirconium is bio-inert and does not cause any allergic reactions;</br>• High mechanical resistance;</br>• In the absence of corrosion in the mouth, saliva can act as an electrolyte, as well as in the presence of various materials in the mouth, which is not the case with zirconium;</br>• Does not cause dark discoloration of the gums and teeth around the neck of porcelain crowns, which is possible with crowns based on metal alloys;</br>• Comfort, because it has a neutral taste and is a light material;</p>",
        broj: 3,
        columnNum: 3,
        imgs: [
          {
            img: mfc1,
            text: "<p>Multilayer zirconia with cutback technique</p>",
          },
          { img: mfc3, text: "<p>Glazed zirconia bridge</p>" },
          { img: mfc2 },
        ],
      },
    },
    {
      dark: {
        broj: 6,
        columnNum: 1,
        imgs: [
          {
            img: mfc4,
            text: "<p>Monolithic zirconia bridge for maximum strength</p>",
          },
        ],
      },
    },
    {
      dark: {
        broj: 7,
        columnNum: 2,
        imgs: [
          { img: mfc5, text: "<p>Thin laminates of zircon FX blank</p>" },
          { img: mfc6 },
        ],
      },
    },
    {
      dark: {
        broj: 9,
        columnNum: 2,
        imgs: [
          {
            img: mfc7,
            text: "<p>Glazed laminates with staining technique</p>",
          },
          { img: mfc8 },
        ],
      },
    },
    {
      dark: {
        broj: 11,
        columnNum: 2,
        imgs: [
          { img: mfc9, text: "<p>Milled monolithic zirconia bridge</p>" },
          {
            img: mfc10,
            text: "<p>The case was made completely monolithic of the highly translucent zirconia.</p>",
          },
        ],
      },
    },
    {
      dark: {
        broj: 13,
        columnNum: 3,
        imgs: [
          {
            img: mfc13,
            text: "<p>Reduced zirconium dioxide which we layered with ceramics to get all the aesthetic details needed to ensure naturalness</p>",
          },
          {
            img: mfc14,
            text: "<p>Making the final structure on the surface of the teeth before the glaze</p>",
          },
          { img: mfc15, text: "<p>Finished glazed bridge</p>" },
        ],
      },
    },
    {
      dark: {
        broj: 16,
        columnNum: 4,
        imgs: [
          {
            img: mfc16Dark,
            text: "<p>We used the highly esthetic lithium disilicate glass-ceramic for this restoration</p>",
          },
          { img: mfc18Dark },
          { img: mfc20 },
          { img: mfc21Dark },
        ],
      },
      light: {
        broj: 20,
        columnNum: 4,
        imgs: [
          {
            img: mfc17Light,
            text: "<p>We used the highly esthetic lithium disilicate glass-ceramic for this restoration</p>",
          },
          { img: mfc19Light },
          { img: mfc20 },
          { img: mfc22Light },
        ],
      },
    },
  ],
};
//---------------------------------------------------------------------------------------------------------------------
////services -> view more on REMOVABLE DENTURES;
export const AllImagePros = [
  MobileProst1,
  MobileProst2,
  MobileProst18Dark,
  MobileProst19Dark,
  MobileProst18Light,
  MobileProst19Light,
  MobileProst3,
  MobileProst4,
  MobileProst5,
  MobileProst6,
  MobileProst7,
  MobileProst8,
  MobileProst9,
  MobileProst10,
  MobileProst11Dark,
  MobileProst12Dark,
  MobileProst11Light,
  MobileProst12Light,
  MobileProst13,
  MobileProst14Dark,
  MobileProst14Light,
  MobileProst15Dark,
  MobileProst16Dark,
  MobileProst17Dark,
  MobileProst15Light,
  MobileProst16Light,
  MobileProst17Light,
];

export const TitleMobilePros = {
  id: "MobileProsthetics",
  title: "Removable Dentures",
};
export const MobileProstPage = {
  imgArr: AllImagePros,
  imagesObjArr: [
    {
      dark: {
        title: "<p>Standard Total Dentures</p>",
        text: "<p>These are dentures that mimic a whole set of upper and lower teeth. This type of prosthesis uses a vacuum to hold it in place.</p><p> They are made of flexible material that makes it easier to get a vacuum. However, because of this, standard total dentures require routine visits to the dentist.</p><p> Because they are flexible, dentures are prone to causing ridge atrophy so the prosthesis no longer fits completely, therefore spaces appear that disrupt the vacuum and the denture swings.</p>",
        broj: 0,
        columnNum: 2,
        imgs: [{ img: MobileProst1 }, { img: MobileProst2 }],
      },
    },
    {
      dark: {
        title: "<p>Partial Dentures</p>",
        text: "<p>Partial dentures are dentures that replace a number of teeth, but not a whole set. A partial denture is a replacement that is supported by the remaining teeth and soft tissues. They are safer than standard total dentures and are more comfortable.</p><p>Dentures remain an effective method of replacing an extracted tooth, replacing them with a removable method. Dentures provide a secure bite, improve chewing function and have an acceptable appearance. Their main drawbacks are everything sometimes they are difficult to bear and make speech and mouth movements difficult.</p><p>The jaw bones around the extracted tooth continue to shrink, and this may lead to gradual collapse of the lower face.</p><p>Depending on the clinical diagnosis, we can provide:</p>• Complete dentures<br/>• Partial dentures<br/>• Prostheses over implants<p>Our staff will explain and recommend the best solutions.</p><p>Complete dentures are either 'conventional' or 'emergency'.</p><p>The conventional denture is implanted one month after all the teeth have been removed to allow proper healing, and the emergency prosthesis is implanted immediately after the teeth are extracted. The downside of these prostheses is that re-alignment will be required once the site has healed.</p><p>It is important to continue with regular check-ups so that the dentist can notice occurrence of abnormalities. As you grow older, your mouth will continue to make changes, and the bone under the prosthesis will shrink and retract. For appropriate maintenance over a longer period of time, adjustment of the dentures or tests for new dentures may be required.</p><p> Never try to set the prosthesis yourself to prolong the period as there may be loss of the bones. When in doubt, please consult our dentists.</p><p>Partial dentures are usually made of acrylic, chrome or valplast and are used for cases where teeth are missing, but there are still some natural teeth left. Reasons for partial dentures are:</p>• Replacement of extracted teeth<br/>• Improving the natural state of chewing<br/>• Help preserve natural teeth<br/>• Help prevent or treat jaw muscle problems<br/>• Improved speech and confident smile<br/>• Replacement of extracted teeth in an economical way<br/>• In most cases with crowned teeth, partial dentures shouldn't be embedded<br/>• Partial dentures are usually made of acrylic, chrome or valplast<br/><p>The partial denture is expected to last about 5 years depending on the circumstances.</p>",
        broj: 2,
        columnNum: 2,
        imgs: [
          {
            img: MobileProst18Dark,
            text: "<p>Standard complete dentures</p>",
          },
          { img: MobileProst19Dark },
        ],
      },
      light: {
        text: "<p>Partial dentures are dentures that replace a number of teeth, but not a whole set. A partial denture is a replacement that is supported by the remaining teeth and soft tissues. They are safer than standard total dentures and are more comfortable.</p><p>Dentures remain an effective method of replacing an extracted tooth, replacing them with a removable method. Dentures provide a secure bite, improve chewing function and have an acceptable appearance. Their main drawbacks are everything sometimes they are difficult to bear and make speech and mouth movements difficult.</p><p>The jaw bones around the extracted tooth continue to shrink, and this may lead to gradual collapse of the lower face.</p><p>Depending on the clinical diagnosis, we can provide:</p>• Complete dentures<br/>• Partial dentures<br/>• Prostheses over implants<p>Our staff will explain and recommend the best solutions.</p><p>Complete dentures are either 'conventional' or 'emergency'.</p><p>The conventional denture is implanted one month after all the teeth have been removed to allow proper healing, and the emergency prosthesis is implanted immediately after the teeth are extracted. The downside of these prostheses is that re-alignment will be required once the site has healed.</p><p>It is important to continue with regular check-ups so that the dentist can notice occurrence of abnormalities. As you grow older, your mouth will continue to make changes, and the bone under the prosthesis will shrink and retract. For appropriate maintenance over a longer period of time, adjustment of the dentures or tests for new dentures may be required.</p><p> Never try to set the prosthesis yourself to prolong the period as there may be loss of the bones. When in doubt, please consult our dentists.</p><p>Partial dentures are usually made of acrylic, chrome or valplast and are used for cases where teeth are missing, but there are still some natural teeth left. Reasons for partial dentures are:</p>• Replacement of extracted teeth<br/>• Improving the natural state of chewing<br/>• Help preserve natural teeth<br/>• Help prevent or treat jaw muscle problems<br/>• Improved speech and confident smile<br/>• Replacement of extracted teeth in an economical way<br/>• In most cases with crowned teeth, partial dentures shouldn't be embedded<br/>• Partial dentures are usually made of acrylic, chrome or valplast<br/><p>The partial denture is expected to last about 5 years depending on the circumstances.</p>",
        broj: 4,
        columnNum: 2,
        imgs: [
          {
            img: MobileProst18Light,
            text: "<p>Standard complete dentures</p>",
          },
          { img: MobileProst19Light },
        ],
      },
    },
    {
      dark: {
        broj: 6,
        columnNum: 3,
        imgs: [
          {
            img: MobileProst3,
            text: "<p>Custom individual removable prosthesis made with composite</p>",
          },
          { img: MobileProst4, text: "<p>Removable dentures in wax</p>" },
          {
            img: MobileProst5,
            text: "<p>Custom gingival toning with acrylic resin for a more natural look</p>",
          },
        ],
      },
    },
    {
      dark: {
        text: "<p>Gingival toning – This technique can give your gums a more natural look through a different variety of natural colour tones and shades to mimic your gums. Usually combined with adding anatomy to create a natural-looking smile, even if the acrylic of the denture base is exposed.</p>",
        broj: 9,
        columnNum: 3,
        imgs: [
          {
            img: MobileProst6,
            text: "<p>Clear thermoplastic flexible prosthesis</p>",
          },
          { img: MobileProst7 },
          { img: MobileProst8 },
        ],
      },
    },
    {
      dark: {
        text: "<p>Patients feel that the appliance “disappears” or is “invisible” in their mouth, thus the esthetics of it is far superior to conventional acrylic/metal partial dentures. Unlike acrylic dentures, they are made from a thermoplastic nylon resin that is ultra thin, very flexible (think more comfortable for chewing and speaking). The material doesn’t absorb odors or stains, and if patients suffer from allergies to acrylic or certain metals, it’s a great choice. It contains no BPAs and is considered the most biocompatible material.</p>",
        broj: 12,
        columnNum: 2,
        imgs: [
          {
            img: MobileProst9,
            text: "<p>Cast partial metal frame and acrylic teeth</p>",
          },
          { img: MobileProst10 },
        ],
      },
    },
    {
      dark: {
        broj: 14,
        columnNum: 2,
        imgs: [
          {
            img: MobileProst11Dark,
            text: "<p>This case is made with cast partial metal frame and with vario-kugel-snap attachments</p>",
          },
          { img: MobileProst12Dark },
        ],
      },
      light: {
        broj: 16,
        columnNum: 2,
        imgs: [
          {
            img: MobileProst11Light,
            text: "<p>This case is made with cast partial metal frame and with vario-kugel-snap attachments</p>",
          },
          { img: MobileProst12Light },
        ],
      },
    },
    {
      dark: {
        text: "<p>Ball attachments are the classic product among attachemnts and are suitable for universal use. The snap effect of the matrices offers the patient comfort and safety.</p>",
        broj: 18,
        columnNum: 1,
        imgs: [
          {
            img: MobileProst13,
            text: "<p>This case is made with cast partial metal frame and with rod attachments</p>",
          },
        ],
      },
    },
    {
      dark: {
        text: "<p>Thanks to a friction surface, the rod attachments provide high reliability during gently insertion of the denture. The various types are suitable for the use both in the anterior and posterior region.</p>",
        broj: 19,
        columnNum: 1,
        imgs: [{ img: MobileProst14Dark, text: "<p>Telescopic crowns</p>" }],
      },
      light: {
        text: "<p>Thanks to a friction surface, the rod attachments provide high reliability during gently insertion of the denture. The various types are suitable for the use both in the anterior and posterior region.</p>",
        broj: 20,
        columnNum: 1,
        imgs: [{ img: MobileProst14Light, text: "<p>Telescopic crowns</p>" }],
      },
    },
    {
      dark: {
        broj: 21,
        columnNum: 3,
        imgs: [
          {
            img: MobileProst15Dark,
            text: "<p>One-sided unilateral partial dentures</p>",
          },
          { img: MobileProst16Dark },
          { img: MobileProst17Dark },
        ],
      },
      light: {
        broj: 24,
        columnNum: 3,
        imgs: [
          {
            img: MobileProst15Light,
            text: "<p>One-sided unilateral partial dentures</p>",
          },
          { img: MobileProst16Light },
          { img: MobileProst17Light },
        ],
      },
    },
  ],
};
/////-----------------------------------------------------------------------------------------------
//Services-> view more on NEW SECTION
// export const AllNewSectionPage = [
//   ColorMatIntro,
//   ColorMat1,
//   ColorMat2,
//   ColorMat3,
// ];
// export const FirstTwoNewSection = [ColorMatIntro, ColorMat1];
// export const SecondTwoNewSection = [ColorMat2, ColorMat3];

// export const NewSectionPage = [
//   {
//     flag: true,
//     text: "<p>Each human tooth has a unique combination of colors, which is like a fingerprint. Reproduction of these complex organic tones in ceramic materials is the biggest challenge faced by every dental dentist graduate.</p><p>The color of some human teeth is an approximate color of the common shades of the color key found in all dental laboratories / surgeries. If your teeth are close to these shades, your doctor can help you successfully choose the shade that matches the natural color of your teeth.</p> <p>Many people still have more complex tooth colors that are not in the standard shades of the color key. In this case, a unique shade must be prepared by an experienced prosthetic graduate. It skillfully mixes and applies to the ceramics in several layers to achieve the desired color shade. The most accurate determination of the perfect color of your teeth requires a physical presence in our laboratories for a perfect match of the color with the natural shade of your teeth.</p>",
//     Images: FirstTwoNewSection,
//   },
//   {
//     text: "<p>In our laboratory 'KREATIVA' you will be welcomed by experienced graduate prosthetists who with special correction lights, will determine your natural tooth color in less than 20 minutes.</p><p>The biggest challenge of any dental laboratory is making a crown or veneer at the top in front of the tooth, because even the slightest color difference in a smile can be too obvious. For such cases it is sometimes necessary for the patient to be present at the laboratory for precise matching.</p><p> This personalized painting can take from 40 minutes to several hours, depending on how many times the ceramic needs to be re-baked and re-painted in order to achieve the desired result.</p>",
//     Images: SecondTwoNewSection,
//   },
// ];

// export const NewSectionData = {
//   title: "New Section",
// };
//----------------------------------------------
//Services-> view more on WAX UP
export const AllWaxupPage = [
  waxup,
  waxup01,
  waxup01a,
  waxup123,
  waxup456,
  waxup7a,
  waxup8,
];

export const WaxupData = {
  title: "Wax Up",
};

export const WaxupPage = {
  imgArr: AllWaxupPage,
  imagesObjArr: [
    {
      dark: {
        broj: 0,
        columnNum: 3,
        imgs: [{ img: waxup }, { img: waxup01 }, { img: waxup01a }],
      },
    },
    {
      dark: {
        broj: 2,
        text: "<p>A wax-up is a three-dimensional model of the mouth, which is taken from impressions, making it an exact replica of the patient’s teeth. This allows the dentist to see what procedures may be required and how it will look when it is finished. This is the most efficient way to achieve the best results as it allows the dentist to take their time on the wax-up, which helps ensure that the work will be aesthetically pleasing.</p><p>Obviously, aesthetics is vastly important in cosmetic work, however, functionality is equally important. This is where the wax-up comes into play as a dentist can perform procedures, such as veneers and crowns, without affecting the patient’s bite.</p><p>Another common use of the wax-up is to make temporary veneers, crowns, and bridges that will match perfectly to the final product. This way the patient can decide if they are happy with the look and feel of their new teeth before going forward with any procedures. Once the patient is happy with the wax-up, the final product can be created. A happy patient equals a happy dentist.</p>",
        columnNum: 1,
        imgs: [{ img: waxup123 }],
      },
    },
    {
      dark: {
        broj: 3,
        text: "<p>In short, the wax-up can be beneficial to both dentist and patient for the following reasons:</p><p>• To diagnose potential problems</br>• To identify the solutions</br>• To design tooth shapes and arch forms before treating a tooth</br>• To diagnose if and how worn teeth can be rebuilt</br>• To give the patient a better understanding of what can be achieved</br>• To fabricate a matrix from the wax-up, which will be used as a mold for the next step of comprehensive cosmetic dentistry: the provisional restorations</p>",
        columnNum: 1,
        imgs: [{ img: waxup456 }],
      },
    },
    {
      dark: {
        broj: 4,
        columnNum: 1,
        imgs: [{ img: waxup7a }],
      },
    },
    {
      dark: {
        broj: 5,
        columnNum: 1,
        imgs: [{ img: waxup8 }],
      },
    },
  ],
};
//----------------------------------------------

//Services-> view more on Retainers
export const AllRetainersPage = [ret1, ret2, ret3, ret4];

export const RetainersPage = {
  imgArr: AllRetainersPage,
  imagesObjArr: [
    {
      dark: {
        text: "<p>Orthodontic retainers are custom-made devices, usually made of wires or clear plastic, that hold teeth in position after surgery or any method of realigning teeth. After a phase of orthodontic treatment to straighten teeth is finished, there is still a lifelong risk of relapse (a tendency for teeth to return to their original position) because of a variety of factors, including the patient's ongoing growth and development, the recoil of periodontal fibers, pressure from the surrounding soft tissues, and the occlusion. The periodontal fibers around the teeth can adjust to changes in the bone by wearing retainers to maintain the teeth in their new positions for a while, which can help reduce alterations to the ultimate tooth position once orthodontic treatment is complete.</p>",
        // broj: 0,
        // text: "Nekoj tekst 1",
        columnNum: 2,
        imgs: [{ img: ret1 }, { img: ret2 }],
      },
    },
    {
      dark: {
        // broj: 2,
        // text: "Nekoj tekst 2",
        columnNum: 2,
        imgs: [{ img: ret3 }, { img: ret4 }],
      },
    },
  ],
};

export const RetainersData = {
  title: "Retainers",
};
//----------------------------------------------

//Services-> view more on PHOTOGRAPHY
export const FirstTwoPhotography = [Photography2, Photography1];

export const PhotographyPage = [
  {
    text: "<p>In Kreativa we have all the necessary photo equipment as well as a photo studio, and besides classical high definition photo work, we also use studio lighting for creating photo presentations that we can use for marketing and presentations and thus help our clients to raise their business to a high level. Photos also help us track the case from the very beginning to the end so that we can see at any time how the case looked before the start of therapy, which allows us to have no unknowns in the process.</p><p>Dental photography not only helps us in the promotion and control of the whole process of making a project, but it also protects us from any unknowns both in the laboratory and in the clinic. Complete photo equipment is not inexpensive and requires additional space and takes some time to learn how to use it, and before you publish your photographs, there is always a little finishing work to be done. As a result, we have decided to provide additional assistance to our dentists and provide them with a complete service of all kinds of photos and save them for marketing promotion or anything else.</p>",
  },
];

export const PhotographyData = {
  title: "Dental Photography",
};
//----------------------------------------------
//Services-> view more on CONSULTATIONS
export const AllConsultationsPage = [
  Consultations1,
  Consultations2,
  Consultations3,
];

export const ConsultationsPage = [
  {
    // flag: true,
    text: "<p>These protocols protect us from complaints, repetition, stress, additional costs, dissatisfied patients and much more so that the patient knows exactly how his or her smile will look like, how long the entire process will last and how much visits a patient will have when he or she enters the prosthetic part of the therapy.</p><p>We want to provide our colleagues and dentists a work planning service so that they can successfully and foreseeably build the case to the very end. We also share knowledge that we gain through intensive education and our rich experience, and we have solved this by offering not only lectures and courses, but also consulting everyone who needs to be able to provide their services at a high level and improve their business.</p><p>Our protocols help large systems, laboratories, clinics that, because of the large volume of work, have a lot of losses due to complaints and repairs. The protocol protects you because it reduces 'garbage' which is a non-refundable loss of money. By introducing our protocols, profit increases and thus reduces stress.</p>",
    Images: AllConsultationsPage,
  },
];

export const ConsultationsData = {
  title: "Consultations",
};
//----------------------------------------------
//Services-> view more on DIGITAL SMILE DESIGN
export const AllDigitalSmileDesignPage = [dsd2, dsd4, dsd3edit, dsd7edit];

export const DigitalSmileDesignData = {
  title: "Digital Smile Design",
};

export const DigitalSmileDesignPage = {
  imgArr: AllDigitalSmileDesignPage,
  imagesObjArr: [
    {
      dark: {
        text: "<p>After assessing a patient's facial features and identifying their specific characteristics, we proceed to incorporate them onto their current teeth. This enables us to create a blueprint for the shape, size, and positioning of their upcoming teeth, resulting in a smile that perfectly complements their facial structure.</p><p>DSD is a very valuable instrument for dealing with all types of circumstances and methods of manufacturing. It's often used for orthodontic therapy, prosthesis production, and large-scale implant work, as well as fixed work, veneers, and crowns. It is critical that the teeth are in the frontal area, which contributes to the majority of the smile's aesthetics.</p>",
        broj: 0,
        columnNum: 2,
        imgs: [{ img: dsd2 }, { img: dsd4 }],
      },
    },
    {
      dark: {
        text: "<p>When a patient is not sufficiently motivated to undergo cosmetic surgery for a variety of reasons, this tool is used to plan all types of work and to help ease any concerns and to demonstrate to the patient how his future smile will appear, what can be done and what cannot be done so that we can perform a thorough case analysis. Because we are explicitly led from the beginning and the patient knows exactly what to expect, when we employ DSD the outcome is predictable and there is no reclamation.</p><p>Digital smile design (DSD) is a tool made up of digital photography, a computer, and—most importantly—a technician or dentist who is designing must be very familiar with the aesthetic parameters, remain objective in situations where they are not ideal, and know how to use their experience, knowledge, and skills with this tool. It's crucial to inform the patient about what is genuinely attractive and natural when creating a fresh smile.</p><p>In addition to providing us with predictable results, less stress, fewer claims, better service, and—most importantly—happy patients, DSD is a tool that will motivate the patient.</p>",
        broj: 2,
        columnNum: 2,
        imgs: [{ img: dsd3edit }, { img: dsd7edit }],
      },
    },
  ],
};

// export const DigitalSmileDesignPage = [
//   {
//     flag: true,
//     text: "<p>After assessing a patient's facial features and identifying their specific characteristics, we proceed to incorporate them onto their current teeth. This enables us to create a blueprint for the shape, size, and positioning of their upcoming teeth, resulting in a smile that perfectly complements their facial structure.</p><p>DSD is a very valuable instrument for dealing with all types of circumstances and methods of manufacturing. It's often used for orthodontic therapy, prosthesis production, and large-scale implant work, as well as fixed work, veneers, and crowns. It is critical that the teeth are in the frontal area, which contributes to the majority of the smile's aesthetics.</p>",
//     Images: FirstTwoDigitalSmileDesign,
//   },
//   {
//     text: "<p>When a patient is not sufficiently motivated to undergo cosmetic surgery for a variety of reasons, this tool is used to plan all types of work and to help ease any concerns and to demonstrate to the patient how his future smile will appear, what can be done and what cannot be done so that we can perform a thorough case analysis. Because we are explicitly led from the beginning and the patient knows exactly what to expect, when we employ DSD the outcome is predictable and there is no reclamation.</p><p>Digital smile design (DSD) is a tool made up of digital photography, a computer, and—most importantly—a technician or dentist who is designing must be very familiar with the aesthetic parameters, remain objective in situations where they are not ideal, and know how to use their experience, knowledge, and skills with this tool. It's crucial to inform the patient about what is genuinely attractive and natural when creating a fresh smile.</p><p>In addition to providing us with predictable results, less stress, fewer claims, better service, and—most importantly—happy patients, DSD is a tool that will motivate the patient.</p>",
//     Images: SecondTwoDigitalSmileDesign,
//   },
// ];
//----------------------------------------------

//---------------------------------------------------------------------
// ----------CASES------------------------------------
export const ImagesMC = [
  MetalCeramics1,
  MetalCeramics2,
  MetalCeramics3,
  MetalCeramics4,
  MetalCeramics5,
  MetalCeramics6,
  MetalCeramics7,
  MetalCeramics8,
  MetalCeramics9,
  MetalCeramics10,
  MetalCeramics11,
  MetalCeramics12,
];
//--------------------------------------------------
export const MCTitle = { title: "Metal Ceramics", imgArr: ImagesMC };
//koga kje se stisne na View more na slikite od Metal Ceramics

export const ImagesMFC = [
  bezmetalna1,
  bezmetalna2,
  bezmetalna3,
  bezmetalna4,
  bezmetalna5,
  bezmetalna6,
];
//----------------------------------------------------------
export const MFCTitle = { title: "Metal-free Ceramics", imgArr: ImagesMFC };
//koga kje se stisne na View more na slikite od Metal-free Ceramics
//// ----------CASES-END------------------------------------

//APPLY FORM
export const ApplyFormData = {
  title: "Apply Form",
};

// export const ApplyNowImages = [ApplyLight, ApplyDark];

// export const EmployeesCard = [
//   {
//     btnData: <ApplyNowButton whereTo="/apply-form" />,
//   },
// ];

export const TitlePrivacyPolicy = {
  title: "Privacy Policy",
};

export const PrivacyPolicyData = [
  {
    title: "<p>Privacy Policy for Kreativa Dental Laboratory</p>",
    text: "<p>At Kreativa Dental Laboratory, we take the privacy and security of our customers' personal information very seriously. This Privacy Policy outlines how we collect, use, disclose, and protect personal information collected from dentists who apply for jobs with us.</p>",
  },
  {
    title: "<p>Information Collected</p>",
    text: "<p>We collect personal information from applicants who apply for jobs with us, such as name, address, phone number, email address, educational and professional qualifications, and employment history. We may also collect any additional information that is required to assess the applicant's suitability for the job.</p>",
  },
  {
    title: "<p>Use of Information</p>",
    text: "<p>We use the personal information collected from job applicants to assess their suitability for the job they have applied for. This may include contacting them about their application, scheduling interviews, verifying their qualifications and references, and conducting background checks.</p>",
  },
  {
    title: "<p>Disclosure of Information</p>",
    text: "<p>We may disclose personal information to third-party service providers who assist us in assessing job applicants, such as employment agencies, educational institutions, and background check providers. We may also disclose personal information when required by law, such as to comply with a court order or legal process.</p>",
  },
  {
    title: "<p>Security</p>",
    text: "<p>We use reasonable physical, technical, and administrative measures to protect the personal information of job applicants from unauthorized access, use, or disclosure. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>",
  },
  {
    title: "<p>Data Retention</p>",
    text: "<p>We retain personal information for as long as necessary to assess job applicants and to comply with legal obligations. After this period, we securely destroy or de-identify personal information in accordance with our data retention policies.</p>",
  },
  {
    title: "<p>Updating Personal Information</p>",
    text: "<p>Job applicants can update their personal information by contacting us directly. We will make reasonable efforts to update or correct personal information as requested.</p>",
  },
  {
    title: "<p>Changes to Privacy Policy</p>",
    text: "<p>We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify job applicants of any material changes to this Privacy Policy by posting a notice on our website or by other means.</p>",
  },
  {
    title: "<p>Contact Us</p>",
    text: "<p>If you have any questions or concerns about our Privacy Policy, please contact us at Kreativa Dental Laboratory.</p>",
  },
]; //Privacy Policy;
